<template>
  <div>
    <OnboardingIndex
      title="Reset Password"
      submit_button_text="Reset Password"
      :verification_running="verification_running || link_verification_running"
      :custom_submit_button="true"
      @custom-submit="reset_password"
    >
      <template v-slot:form-content>
        <div class="mx-auto w-100">
          <div v-if="link_verification_running" class="text-center small text-muted py-3">
            Verifying reset link...
          </div>

          <div v-else-if="link_error" class="text-center py-3">
            <p class="small text-danger mb-3">{{ link_error }}</p>
            <router-link
              :to="{ name: 'ForgotPassword' }"
              class="fw-semibold text-decoration-none small text-xs"
            >
              Request a new reset link
            </router-link>
          </div>

          <template v-else>
            <div class="mb-4">
              <label for="new_password" class="text-xs mb-2">New Password</label>
              <input
                id="new_password"
                v-model="new_password"
                type="password"
                class="form-control form-control-sm text-xs bg-light border-0 py-2"
                placeholder="Enter New Password"
                required
              />
            </div>

            <div class="mb-4">
              <label for="confirm_password" class="text-xs mb-2">Confirm Password</label>
              <input
                id="confirm_password"
                v-model="confirm_password"
                type="password"
                class="form-control form-control-sm text-xs bg-light border-0 py-2"
                placeholder="Confirm New Password"
                required
              />
            </div>

            <router-link
              :to="{ name: 'UserLogin' }"
              class="fw-semibold text-decoration-none small text-xs"
            >
              Back to Login
            </router-link>
          </template>
        </div>
      </template>

      <template v-slot:custom-button>
        <div v-if="!link_verification_running && !link_error" class="d-grid pt-1">
          <button
            type="submit"
            class="btn btn-primary-dark shadow w-100"
            :disabled="verification_running"
          >
            {{ verification_running ? 'Resetting...' : 'Reset Password' }}
          </button>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
